import { Routes } from '@angular/router';
import { RouterConst } from './utils/router.consts';
import { loggedGuard } from './guards/logged.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: RouterConst.DASHBOARD.PATH,
    pathMatch: 'full',
  },
  {
    path: RouterConst.DASHBOARD.PATH,
    loadChildren: () => import('./dashboard/dashboard.routes').then(m => m.routes),
    canActivate: [loggedGuard],
  },
  {
    path: RouterConst.AUTHENTICATION.PATH,
    loadChildren: () => import('./auth/auth.routes').then(m => m.default),
  },
  { path: '**', redirectTo: RouterConst.DASHBOARD.PATH },
];
